export const isAnchor = (element?: Node | null): element is HTMLAnchorElement =>
  element instanceof HTMLAnchorElement;
